import React, { useState } from 'react';

const PIECES = [
  '10',
  '9',
  '8', '8',
  '7', '7', '7',
  '6', '6', '6', '6',
  '5', '5', '5', '5',
  '4', '4', '4', '4',
  '3', '3', '3', '3', '3',
  '2', '2', '2', '2', '2', '2', '2', '2',
  '1',
  'B', 'B', 'B', 'B', 'B', 'B',
  'F',
];

function shuffle(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

function Stratego() {
  const [grid, setGrid] = useState(Array(40).fill(null));
  const [randomized, setRandomized] = useState(false);
  const [active, setActive] = useState(new Set());

  const randomize = () => {
    setGrid(shuffle(PIECES));
    setActive(new Set());
    setRandomized(true);
  };

  const toggleCell = (i) => {
    setActive(prev => {
      const next = new Set(prev);
      next.has(i) ? next.delete(i) : next.add(i);
      return next;
    });
  };

  return (
    <div className="stratego-page">
      <h1 className="stratego-title">Stratego</h1>
      <div className="stratego-grid">
        {grid.map((piece, i) => (
          <div
            key={i}
            className={`stratego-cell${active.has(i) ? ' stratego-cell--active' : ''}`}
            onClick={() => piece && toggleCell(i)}
          >
            {piece || ''}
          </div>
        ))}
      </div>
      <div className="stratego-actions">
        <button className="stratego-btn" onClick={randomize}>
          {randomized ? 'Randomize again' : 'Randomize'}
        </button>
      </div>
    </div>
  );
}

export default Stratego;
